export class DatosAreaMinera {
  id?: number;
  denominacion: string;
  codigo_unico: number;
  padron_nacional: string;
}
